<style scoped>
table tr td {
  text-align: left !important;
}
table {
  text-align: left !important;
}
</style>
<template>
  <CCard>
    <CCardHeader
      style="background:#1a3665;color:white"
      class="d-flex align-items-center font-weight-bold justify-content-between"
    >
      Anggota Umum
      <template v-if="role_status && role_status.status_export_excel">
      <CButton color="info" class="btn-md ml-auto">Ekspor Excel</CButton>    
      </template>  
    </CCardHeader>
    <CCardBody>     
      <CRow>
        <div class="col-sm-12 col-xl-2">
          <div class="form-group">
            <label for>Data Perhalaman</label>
            <select class="form-control" name id @change="changePageSize">
              <option>10</option>
              <option>25</option>
              <option>100</option>
              <option value="Semua Data">Semua Data</option>
            </select>
          </div>
        </div>        
        <div class="col-sm-12 col-xl-3 ml-auto">
          <div class="form-group">
            <label for>Pencarian</label>
            <input
              type="text"
              name
              id
              class="form-control"
              placeholder="Cari Data ..."
              v-model="search"
            />
          </div>
        </div>        
      </CRow>
      <CRow>
        <CCol lg="12" class="table-responsive">
          <CDataTable
            style="widht:100% !important; text-align: left"
            :items="items"
            :fields="fields"
            hover
            sorter
          >
            <template #no="{index}">
              <td class="py-2">{{index+1}}</td>
            </template>
            <template #no_anggota="{item}">
              <td class="py-2 font-weight-bold">{{item.no_anggota ? item.no_anggota : "-"}}</td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2">{{item.nama_lengkap ? item.nama_lengkap : "-"}}</td>
            </template>
            <template #nama_kategori="{item}">
              <td class="py-2">{{item.nama_kategori ? item.nama_kategori : "-"}}</td>
            </template>
            <template #nominal="{item}">
              <td class="py-2">Rp. {{(item.nominal) ? (item.nominal) : "-"}}</td>
            </template>
             <template #status_pembayaran="{item}">
              <td class="py-2 font-weight-bold text-success" v-if="item.status_pembayaran == 'settlement'">Lunas</td>              
              <td class="py-2 font-weight-bold text-warning" v-else-if="item.status_pembayaran == 'pending'">Menunggu Pembayaran</td>              
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == 'expire'">Expired</td>              
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == 'failure'">Pembayaran Gagal</td>
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == '0'">Belum Lunas</td>
              <td class="py-2 font-weight-bold text-danger"  v-else-if="item.status_pembayaran == null">Belum Lunas</td>
              <td class="py-2 font-weight-bold text-danger"  v-else>-</td>
            </template>
            <template #status_persyaratan="{item}">
              <td class="py-2">
                <button
                  class="btn btn-sm btn-success"
                  v-if="item.status_persyaratan   == 1"
                >Terverifikasi</button>
                <button class="btn btn-sm btn-danger" v-else>Belum Terverifikasi</button>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 d-flex align-items-center">
                <template v-if="role_status && role_status.status_update">
                <CButton 
                  :disabled="item.status_dokumen == 0 || item.status_pembayaran != 'settlement'" 
                  :color="item.status_dokumen == 0 || item.status_pembayaran != 'settlement' ? 'secondary' :'info'" 
                  square size="sm" 
                  v-c-tooltip="'Edit'" 
                  @click="updateData(item, index)">
                  <font-awesome-icon icon="edit"  />
                </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_read">
                  <router-link
                    :to="'/keanggotaan/anggota-umum/pengajuan-rekomendasi/'+item.id_anggota_umum"
                    class="mx-1"
                  >
                    <CButton color="success" square v-c-tooltip="'Dokumen'" size="sm">
                      <font-awesome-icon icon="file" />
                    </CButton>
                  </router-link>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                <CButton color="danger" square size="sm" v-c-tooltip="'Hapus'" @click="deleteData(item, index)">
                  <font-awesome-icon icon="trash" />
                </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>

      <!-- Modal Tambah -->
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body mt-n2">
              <form>
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <label for="nomor_agt" class="font-weight-bold">Nomor Anggota IAPI</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nomor_agt"
                      placeholder="Terisi Otomatis"
                      readonly
                      v-model="formData.no_anggota"
                    />
                    <input type="hidden" v-model="formData.id_anggota_umum" />                    
                  </div>
                  <input type="hidden" v-model="formData.id_user" />
                  <div class="form-group col-md-12">
                    <label
                      for="nama_lengkap_agt font-weight-bold"
                      class="font-weight-bold"
                    >Nama Lengkap Anggota</label>
                    <input
                      type="text"
                      class="form-control"
                      id="nama_lengkap_agt"
                      placeholder="Terisi Otomatis"
                      readonly
                      v-model="formData.nama_lengkap"
                    />
                  </div>
                </div>
                <div class="form-group">
                  <label for="kategori_agt" class="font-weight-bold">Kategori Anggota</label>
                  <input
                    type="text"
                    class="form-control"
                    id="kategori_agt"
                    placeholder="Terisi Otomatis"
                    readonly
                    v-model="formData.nama_kategori"
                  />
                </div>
                <div class="form-group">
                  <label for="email_agt" class="font-weight-bold">Email Anggota</label>
                  <input
                    type="text"
                    class="form-control"
                    id="email_agt"
                    placeholder="Terisi Otomatis"
                    readonly
                    v-model="formData.email"
                  />
                </div>
                <div class="form-group">
                  <label for="alamat" class="font-weight-bold">Alamat</label>
                  <textarea
                    type="text"
                    class="form-control"
                    id="alamat"
                    placeholder="Terisi Otomatis"
                    readonly
                    v-model="formData.alamat_ktp"
                  />
                </div>
                <div class="form-group">
                  <label for class="font-weight-bold">Status</label>
                  <br />
                  <div class="d-flex align-items-center">
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        value="1"
                        v-model="formData.status_persyaratan"
                        id="aktif"
                      />
                      <label class="custom-control-label" for="aktif">Terverifikasi</label>
                    </div>
                    <div class="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        class="custom-control-input"
                        name="customRadio"
                        value="0"
                        id="tidak_aktif"
                        v-model="formData.status_persyaratan"
                      />
                      <label class="custom-control-label" for="tidak_aktif">Belum Terverifikasi</label>
                    </div>
                  </div>
                </div>
                <div class="form-group" v-show="formData.status_persyaratan == '0'">
                  <label for="alamat" class="font-weight-bold">Alasan</label>
                  <textarea
                    type="text"
                    class="form-control"
                    id="alamat"
                    v-model="formData.alasan"
                  />
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
        </template>
        <template #footer>
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
          <CButton @click="postData" type="submit" color="success">Simpan</CButton>
        </template>
      </CModal>
      <!-- End Modal -->
    </CCardBody>
  </CCard>
</template>
<script>
import AnggotaUmumService from "@/services/keanggotaan/anggota-umum/anggota-umum.service";
import {AlertUtils} from "@/mixins/AlertUtils"
import {Pagination} from "@/mixins/Pagination"

const fields = [
  {
    key: "no",
    sorter: true,
    filter: true
  },
  {
    key: "no_anggota",
    label: "No. Anggota",
    sorter: true,
    filter: true,
    _style: "font-weight: bold"
  },
  {
    key: "nama_lengkap",
    label: "Nama Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "nama_kategori",
    label: "Kategori Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "nominal",
    label: "Nominal",
    sorter: false,
    filter: false
  },
  {
    key: "status_pembayaran",
    label: "Status Pembayaran",
    sorter: false,
    filter: false
  },
  {
    key: "status_persyaratan",
    _style: " text-align: center",
    sorter: true,
    filter: true
  },
  {
    key: "aksi",
    _style: "width:12.2%; text-align: center",
    sorter: true,
    filter: true
  }
];

export default {
  mixins: [AlertUtils, Pagination],
  data() {
    return {
      items: [],
      actionPost: "",
      dataUser: [],
      pageSize: "",
      filterKategori: 'default',
      dataKategoriAnggota: {},
      multi_user: [
        {
          id_user: null,
          email: "",
          nama_lengkap: null,
          nama_kategori: "",
          alamat: "",
          no_anggota: ""
        }
      ],
      formData: {
        status: "",
        alasan : "",
        id_anggota_umum: "",
        id_user: "",
        email: "",
        nama_lengkap: "",
        nama_kategori: "",
        alamat: "",
        no_anggota: "",
        alasan: "",
        namaKategori: "",
        statusPersyaratan: ""
      },
      pagination: {
        totalPages: 0
      },
      fields,
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      myModalDetail: false,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      indexed: 0,
      title: "",
      role_status: null
    };
  },
  mounted() {
    this.roleData();
    this.getData("0", this.pageSize, "default", 'default');
  },
  watch: {
    multi_user: function(val) {
      this.formData.idUser = val.id_user;
    },
  },

  methods: {
    roleData()
      {
        var user = JSON.parse(localStorage.getItem('user'));
        var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
        this.role_status = data;
      },
    deleteData(item, index) {
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            AnggotaUmumService.deleteAnggotaUmum(this.formData.id_anggota_umum)
              .then(response => {
                // comment console console.log(response);
                this.alertDeleteSuccess();
                this.getData("0", this.pageSize, this.search);
              })
              .catch(error => {
                this.alertError();
                // comment console console.log(error);
              });
            Toast.fire({
              icon: "cancel",
              title: "Data Berhasil Dihapus"
            });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            this.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },

    getData(currentPage, pageSize, filter, filterKategori) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      AnggotaUmumService.getAnggotaUmum(currentPage, pageSize, filter, filterKategori)
        .then(response => {
          // comment console console.log(response)
          loader.hide();
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
        });
    },    

    createData() {
      this.myModal = true;

      this.formData = {};

      this.actionPost = "insert";
      this.title = "Tambah";
    },

    updateData(item, index) {
      this.myModal = true;
      this.formData = item;
      this.formData.status_persyaratan = item.status_persyaratan;      
      this.formData.alasan = item.alasan
      this.actionPost = "update";
      this.title = "Edit";
    },

    postData() {
      if (this.actionPost == "insert") {
        this.insertData(this.formData);
      } else if (this.actionPost == "update") {
        this.putData();
      }
    },

    insertData(formData) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log(formData);
      // comment console console.log("post");
      AnggotaUmumService.postAnggotaUmum(formData)
        .then(response => {
          this.myModal = false;
          this.alertSuccess();
          this.getData("0");
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    },

    putData() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      // comment console console.log("put");
      // comment console console.log(this.formData);

      // var vm = this;
      AnggotaUmumService.putAnggotaUmum(this.formData)
        .then(response => {
          loader.hide();
          // comment console console.log("ini edit data");
          this.myModal = false;
          this.alertEditSuccess();
          this.getData("0", this.pageSize, "default");
        })
        .catch(error => {
          loader.hide();
          // comment console console.log(error);
          this.alertError();
        });
    }
    
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>